import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const OffersPage = () => {
  const { id } = useParams();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://taaiappapi.emedha.in/pages/api/get/offers")
      .then((res) => res.json())
      .then((data) => {
        setOffers(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Loading offers...</div>;
  }

  return (
    <div style={{ padding: "20px", background: "#f4f6fb", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ textAlign: "center", color: "#303381", marginBottom: "30px" }}>
        Exclusive Offers for TAAI Members
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
        }}
      >
        {offers.map((offer) => (
          <div
            key={offer.id}
            style={{
              background: "#fff",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
              position: "relative",
              transition: "transform 0.2s",
            }}
          >
            {/* Discount Ribbon */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                backgroundColor: "#e63946",
                color: "#fff",
                padding: "5px 10px",
                fontWeight: "bold",
                borderTopLeftRadius: "12px",
                borderBottomRightRadius: "12px",
                fontSize: "0.85rem",
                zIndex: 1,
              }}
            >
              {offer.discount}% OFF
            </div>

            <img
              src={offer.image}
              alt={offer.title}
              style={{ width: "100%", height: "180px", objectFit: "cover" }}
            />

            <div style={{ padding: "15px" }}>
              <h3 style={{ margin: "0 0 10px", color: "#2c2f7a", fontSize: "1.1rem" }}>
                {offer.title}
              </h3>

              <p style={{ margin: "5px 0", fontSize: "0.9rem", color: "#555" }}>
                Coupon Code: <strong>{offer.coupon}</strong>
              </p>

              <p style={{ margin: "5px 0", fontSize: "0.8rem", color: "#777" }}>
                Valid: {formatDate(offer.start_date)} → {formatDate(offer.expiry_date)}
              </p>

              {/* <button
                style={{
                  marginTop: "10px",
                  width: "100%",
                  backgroundColor: "#ff9900",
                  color: "#fff",
                  padding: "10px",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  transition: "background 0.3s",
                }}
                onClick={() => {
                  navigator.clipboard.writeText(offer.coupon);
                  alert(`Coupon code ${offer.coupon} copied!`);
                }}
              >
                Redeem Coupon
              </button> */}
            </div>
          </div>
        ))}
      </div>

      <div style={{ textAlign: "center", marginTop: "40px", fontSize: "0.85rem", color: "#333" }}>
        Membership ID: <strong>{id}</strong>
      </div>
    </div>
  );
};

export default OffersPage;
